import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Button, TextField, Switch, Modal, Box, Typography,IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { fetchToken } from '../../../Auth';
import { adminURL } from '../../../global';
import { toast } from 'react-toastify';
import { checkRoute } from '../../../services/auth';
import CloseIcon from '@mui/icons-material/Close';

const TechDashboard = () => {
  const [dashboards, setDashboards] = useState([]);
  const [editRowId, setEditRowId] = useState(null);
  const [updatedRow, setUpdatedRow] = useState({});
  const [openAddModal, setOpenAddModal] = useState(false);
  const [newDashboard, setNewDashboard] = useState({ dashboard: '', route_url: '', is_live: false });
  const navigate = useNavigate();
  const [editableDashboards, setEditableDashboards] = useState([]);

  useEffect(() => {
    const verifyRoute = async () => {
      try {
        const response = await checkRoute(navigate, adminURL); 
        console.log('Route check response:', response);
      } catch (err) {
        console.log('Route check failed:', err);
      }
    };

    verifyRoute();
  }, [navigate, adminURL]);
  
  useEffect(() => {
    getDashboards();
    isSuperAdmin();
  }, []);

  const getDashboards = async () => {
    try {
      const response = await axios.get(`/get_dashboards/all`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
        },
      });
      if (response.status === 200 && response.data) {
        setDashboards(response.data.dashboards);
        setEditableDashboards(response.data.dashboards);
      }
    } catch (err) {
      if (err.response?.status === 401) {
        navigate(`/niyantran-panel/${adminURL}/login`);
      }
    }
  };

  const isSuperAdmin = async () => {
    try {
      const response = await axios.get(`/is_super_admin`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
        },
      });
      if (response.status === 200 && response.data === false) {
        navigate('/error');
      }
    } catch (err) {
      if (err.response?.status === 401) {
        navigate(`/niyantran-panel/${adminURL}/login`);
      }
    }
  };
  const handleEditChange = (e, id, field) => {
    setEditableDashboards((prevDashboards) =>
      prevDashboards.map((d) =>
        d._id === id ? { ...d, [field]: e.target.value } : d
      )
    );
  };
  

  // const handleSave = async () => {
  //   try {
  //     await axios.post(`/edit_dashboard`, updatedRow, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
  //       },
  //     });
  //     toast.success("Dashboard updated successfully!");
  //     getDashboards()
  //   } catch (error) {
  //     toast.error("Update failed");
  //   }
  //   setEditRowId(null);
  //   setUpdatedRow({});
  // };

  const handleSave = async (id) => {

    const dashboardToUpdate = editableDashboards.find((d) => d._id === id);

    
    if (!dashboardToUpdate) {
      toast.error("Dashboard not found!");
      return;
    }
  
    try {
      await axios.post(`/edit_dashboard`, { 
        _id: id, 
        dashboard: dashboardToUpdate.dashboard 
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
        },
      });
  
      toast.success("Dashboard updated successfully!");
      getDashboards()
  
    } catch (error) {
      toast.error(error.response.data.msg);
    }
  
    setEditRowId(null);
  };
  
  

const handleCancel = () => {
  setEditableDashboards([...dashboards]);
  setEditRowId(null);
};


  // const handleDelete = async (id) => {
  //   try {
  //     await axios.post(`/delete_dashboard`,{
  //       id: id,
  //     }, {
  //       headers: {
  //         'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
  //       },
  //     });
  //     toast.success("Dashboard deleted successfully!");
  //     getDashboards()
  //   } catch (error) {
  //     toast.error("Delete failed");
  //   }
  // };

  const handleToggleStatus = async (id, isLive) => {
    try {
      await axios.post(`/change_live_status`, {
        _id: id,
        is_live: !isLive,
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
        },
      });
      toast.success("Status updated successfully!");
      getDashboards()
    } catch (error) {
      toast.error(error.response.data.msg);
    }
  };

  const handleAddDashboard = async () => {
    if (!newDashboard.dashboard || !newDashboard.route_url) {
      toast.error("Dashboard Name and Route URL are required!");
      return;
    } 
    try {
      const response = await axios.post(`/add_dashboard`, newDashboard, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
        },
      });

      toast.success("Dashboard added successfully!");
      setOpenAddModal(false);
      getDashboards()
    } catch (error) {
      toast.error(error.response.data.msg);
    }
  };
  

  const columns = [
    {
      field: 'dashboard',
      headerName: 'Dashboard Name',
      flex: 1,
      renderCell: (params) =>
        editRowId === params.row._id ? (
          <TextField
            value={editableDashboards.find(d => d._id === params.row._id)?.dashboard || ''}
            onChange={(e) => handleEditChange(e, params.row._id, 'dashboard')}
            onKeyDown={(e) => e.stopPropagation()} 
            fullWidth
          />
        ) : (
          params.value
        ),
    },
    
    
    {
      field: 'route',
      headerName: 'Dashboard Route URL',
      flex: 1,
      renderCell: (params) => params.value ? params.value : '-',
    },    
    // {
    //   field: 'is_live',
    //   headerName: 'Live Status',
    //   flex: 0.5,
    //   renderCell: (params) => (
    //     <Switch checked={params.value} onChange={() => handleToggleStatus(params.row._id, params.value)} disabled={editRowId !== null} />
    //   ),
    // },
    {
      field: 'last_updated_by',
      headerName: 'Updated by',
      flex: 1,
      renderCell: (params) => params.value ? params.value : '-',
    },
    {
      field: 'last_updated_at',
      headerName: 'Updated at',
      flex: 1,
      renderCell: (params) => params.value ? params.value : '-',
    },

    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.5,
      renderCell: (params) =>
        editRowId === params.row._id ? (
          <>
            {/* Pass row ID to handleSave */}
            <GridActionsCellItem icon={<SaveIcon />} label="Save" onClick={() => handleSave(params.row._id)} />
            <GridActionsCellItem icon={<CancelIcon />} label="Cancel" onClick={handleCancel} />
          </>
        ) : (
          <>
            <GridActionsCellItem icon={<EditIcon />} label="Edit" 
              onClick={() => { 
                setEditRowId(params.row._id);
                setEditableDashboards([...dashboards]);
              }} 
            />
          </>
        ),
    }
    
  ];

  const confirmSaveChanges = () => {
    const userConfirmed = window.confirm("Are you sure you want to cancel? Your changes will be lost.");
    if (userConfirmed) {
        setNewDashboard("")
      setOpenAddModal(false); 
    }
    
  };
  return (
    <section className='w-100 row p-2'>
      <div className='admin-card corner row p-3 shadow-2 w-100'>
        <div className='col-8'>
          <h1 className='bold'>Tech Dashboard</h1>
          <p className='medium-3 text-muted'>Manage dashboard.</p>
        </div>
        <div className='col-3 d-flex justify-content-end'>
          <Button variant="contained" startIcon={<AddIcon />} style={{height:'3em'}} onClick={() => setOpenAddModal(true)}>
            Add Dashboard
          </Button>
        </div>
      </div>

      <div className='admin-card corner row p-3 shadow-2 w-100 mt-3' >
        {
          dashboards && (
            <>
        <DataGrid rows={dashboards} columns={columns} getRowId={(row) => row._id} disableSelectionOnClick />
            </>
          )
        }
      </div>

      <Modal open={openAddModal} onClose={() => setOpenAddModal(false)}>
        <Box sx={{ p: 3, backgroundColor: 'white', borderRadius: 2, margin: 'auto', marginTop: '10%', width: 400 }}>
          <div style={{position:'relative'}}>
        <IconButton
          aria-label="close"
          onClick={confirmSaveChanges}
          sx={{
            position: 'absolute',
            top: "-1em",
            right: "-1em",
            color: 'grey.500',
          }}
        >
          <CloseIcon />
        </IconButton>

          <Typography variant="h6">Add New Dashboard</Typography>
          </div>
          {/* Dashboard Name Input */}
          <TextField
            label="Dashboard Name"
            fullWidth
            margin="normal"
            value={newDashboard.dashboard}
            onChange={(e) => setNewDashboard({ ...newDashboard, dashboard: e.target.value })}
          />

          {/* Dashboard Route URL Input */}
          <TextField
            label="Dashboard Route URL"
            fullWidth
            margin="normal"

            value={newDashboard.route_url}
        
            onChange={(e) => setNewDashboard({ ...newDashboard, route_url: e.target.value })}
          />

          {/* Toggle Button for Live Status */}
          {/* <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
            <Typography variant="body1" sx={{ mr: 2 }}>Live Status:</Typography>
            <Switch
              checked={newDashboard.is_live}
              onChange={() => setNewDashboard({ ...newDashboard, is_live: !newDashboard.is_live })}
            />
          </Box> */}

          {/* Add Button */}
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleAddDashboard}
            disabled={!newDashboard.dashboard || !newDashboard.route_url} 
          >
            Add Dashboard
          </Button>
        </Box>
      </Modal>

    </section>
  );
};

export default TechDashboard;
